module.exports = __webpack_public_path__ + "img/tms.6ad83b34.svg";